import { Comment, Text, type Slot, type VNode, Fragment } from 'vue'

export function hasSlotContent(slot: Slot | undefined | null, props: any = {}): boolean {
  return !isSlotEmpty(slot, props)
}

function isSlotEmpty(slot: Slot | undefined | null, props: any = {}): boolean {
  return isVNodeEmpty(slot?.(props))
}

function isVNodeEmpty(vnode: VNode | VNode[] | undefined | null): boolean {
  return (
    !vnode ||
    asArray(vnode).every(
      (vnode) =>
        vnode.type === Comment || (vnode.type === Text && !vnode.children?.length) || (vnode.type === Fragment && !vnode.children?.length),
    )
  )
}

function asArray<T>(arg: T | T[] | null): T[] {
  return Array.isArray(arg) ? arg : arg === null ? [] : [arg]
}
